import { Guid } from 'Lib/Guid';
import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi, camelizeObjectKeys } from '../../Helpers/rxjsHelpers';

const mapRootPathMapResponse = (r: any) => camelizeObjectKeys(r);

export const callApiPutStandardisation = (body: any, params: any) => {
  return callApi(webApi['equipment.nucleargauge.standardization'].put(body, params)).pipe(
    map((r) => mapRootPathMapResponse(r.Body))
  );
};

export const callApiGetStandardisation = (equipmentId: Guid, path = null) => {
  return callApi(webApi['equipment.nucleargauge.standardization'].get({ equipmentId })).pipe(
    map((r) => mapRootPathMapResponse(r.Body))
  );
};
